import jssVariables from "../../../jss_setup";

export const mainPromoStyles = {
  mainPromo: {
    gridGap: "0px!important",
    smallscreen: {
      gridGap: "0px!important",
    },
    bigscreen: {
      gridGap: "0px!important",
    },
  },
  MPHotels: {
    padding: [`calc(${jssVariables.normal_gap} * 3)`, 0],
    header: {
      fontSize: "40px",
    },
    items: {
      smallscreen: {
        gridGap: jssVariables.double_gap,
        gridTemplateColumns: "repeat(4, 1fr)",
      },
      bigscreen: { gridGap: `calc(${jssVariables.double_gap} * 2)` },
    },
  },
};
